// Tiny className joiner. We don't need clsx — a 5-line helper covers our use case.
export type ClassValue = string | false | null | undefined;

export function cn(...classes: ClassValue[]): string {
  return classes.filter(Boolean).join(' ');
}
